var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.381,
    height: 20.921,
    viewBox: "0 0 31.381 20.921",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-video",
    "data-name": "Icon awesome-video",
    d: "M18.316,4.5H2.6A2.6,2.6,0,0,0,0,7.1V22.816a2.6,2.6,0,0,0,2.6,2.6H18.316a2.6,2.6,0,0,0,2.6-2.6V7.1A2.6,2.6,0,0,0,18.316,4.5ZM28.635,6.554l-5.971,4.119v8.575l5.971,4.113a1.747,1.747,0,0,0,2.746-1.406v-14A1.748,1.748,0,0,0,28.635,6.554Z",
    transform: "translate(0 -4.5)",
    fill: "#774f9f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVideo);
export default __webpack_public_path__ + "static/media/icon-video.d7ab9c0dd554f4ef5ed1a237173b1b44.svg";
export { ForwardRef as ReactComponent };